import React, { useState } from 'react';
import HarbourModal from './HarbourModal';
import HarbourNotice from './HarbourNotice';
import { apiSendSchoolUserPasswordReset } from '../../utils/rmsApi';
import {
  RESET_NOTHING_ARRIVED,
  RESET_SEND_ANOTHER,
  RESET_SEND_FAILED,
  RESET_SENT_TITLE,
  resetSentBody,
} from '../../constants/passwordReset';
import './harbour.css';

/*
 * Change password, from the school account menu (TDI-702, F-01 FR6). A
 * signed-in SENCO or class teacher is emailed a reset link to the address
 * they are signed in with: the address is shown, never typed, so the link
 * can only go to the account's own inbox. Then the same "Check your email"
 * words as the sign-in page's card, without "Used the wrong address?".
 *
 * Uses rmsSendSchoolUserPasswordReset, which answers the same whatever
 * happens. Nothing changes until the person follows the link and sets a new
 * password, so a second tab stays signed in until then.
 */
export const CHANGE_PASSWORD_COPY = {
  title: 'Change your password',
  body: (email) => `We'll email a link to ${email}. It works once and runs out after an hour.`,
  send: 'Email me a link',
  close: 'Close',
};

export default function HarbourChangePasswordDialog({ email, onClose }) {
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  // Every press sends a fresh link; the server replaces the earlier one.
  const send = async () => {
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      await apiSendSchoolUserPasswordReset({ email });
      setSent(true);
    } catch (_) {
      setError(RESET_SEND_FAILED);
    } finally {
      setBusy(false);
    }
  };

  // The key remounts the dialog when it changes step, so focus moves to the
  // new title and a screen reader hears "Check your email" once.
  if (!sent) {
    return (
      <HarbourModal
        key="ask"
        title={CHANGE_PASSWORD_COPY.title}
        confirmLabel={CHANGE_PASSWORD_COPY.send}
        onConfirm={send}
        onClose={onClose}
        busy={busy}
      >
        <p className="harbour-body-16">{CHANGE_PASSWORD_COPY.body(email)}</p>
        {!!error && <HarbourNotice kind="error" title={error} />}
      </HarbourModal>
    );
  }

  return (
    <HarbourModal
      key="sent"
      title={RESET_SENT_TITLE}
      cancelLabel={CHANGE_PASSWORD_COPY.close}
      confirmKind="secondary"
      confirmLabel={RESET_SEND_ANOTHER}
      onConfirm={send}
      onClose={onClose}
      busy={busy}
    >
      <p className="harbour-body-16">{resetSentBody(email)}</p>
      <p className="harbour-body-16 text-[color:var(--harbour-colour-text-muted)]">{RESET_NOTHING_ARRIVED}</p>
      {!!error && <HarbourNotice kind="error" title={error} />}
    </HarbourModal>
  );
}
